<section class="similar-patients-view page-content">


  <header *ngIf="isPatientContext" class="header profile-header">
    <div class="Flexbox">
      <div class="header-content contnet-filters Flexbox Flexbox__flex-1 fs5">
        <gen-test-header-elements
                class="content-item Flexbox Spacebox__lr-small patient-profile profile-header-section"
                style="font-size: 1.21rem; flex-wrap: wrap; flex: 1 1 auto"
                [patientId]="patientId">

        </gen-test-header-elements>

      </div>
    </div>
  </header>

  <section class="similar-patients-content-with-filter">
      <gen-filter-panel-wrapper
                class="sp-filter-panel"
                [type]="filterType"
                [subtype]="filterSubtype"
                [resourceTitle]="'Settings'"
                [clearFilterTranslateKey]="'CLEAR_SETTINGS'"
                [enableStatistics]="false"
                (updatePanelState)="updatePanelState($event)">
      </gen-filter-panel-wrapper>

      <section class="similar-patients-content"
               [ngClass]="{'filter-panel-open similar-patients-content-filter-open': isFilterPanelOpen, 'filter-panel-closed': !isFilterPanelOpen}">

        <gen-dynamic-form class="similar-patients-dynamic-form"
                [title]="'Patient Analytics'"
                [formName]="'PATIENT-ANALYTICS-FORM'"
                [formData]="formData"
                [updateOnBlur]="false"
                [listenToDataChange]="false"
                [editMode]="false"
                (formChange)="onFormDataChanged($event)">
        </gen-dynamic-form>

      </section>

  </section>

  <section class="similar-patients-view-actions">

    <span class="similar-patients-view-action">
      <gen-button
              [text]="'Close'"
              (click)="closeViewAndGoBack()">
      </gen-button>
    </span>

  </section>

</section>
